import ChangeUserSkillIconModal from './ChangeUserSkillIconModal'

export default ChangeUserSkillIconModal
